import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { icons } from '~/assets';
import activeGrupoEconomicoIcon from '~/assets/svg/active-grupo-economico.svg';
import activePessoaFisicaIcon from '~/assets/svg/active-pessoa-fisica.svg';
import activePessoaJuridicaIcon from '~/assets/svg/active-pessoa-juridica.svg';
import grupoEconomicoIcon from '~/assets/svg/grupo-economico.svg';
import pessoaFisicaIcon from '~/assets/svg/pessoa-fisica.svg';
import pessoaJuridicaIcon from '~/assets/svg/pessoa-juridica.svg';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Loading from '~/components/loading';
import Tabs from '~/components/tab';
import useApi, { ApiMethod } from '~/hooks/useApi';
import {
  CompanyDataBodyRequest,
  CompanyDataResponse,
  GeneralParametersData,
  SplitsModality,
} from '~/services/banknow/types';
import Endpoints from '~/services/endpoints';
import { httpRequest } from '~/services/httpRequest';
import {
  cepMask,
  cnpjMask,
  cpfMask,
  dateMask,
  IDefaultReturn,
  phoneMask,
} from '~/utils/masks';
import * as St from '../styles';
import { BusinessGroupEstablishment } from './components/BusinessGroupEstablishment';
import CNPJEstablishment from './components/CNPJEstabilishment';
import CPFEstablishment from './components/CPFEstabilishment';

interface Address {
  cep?: string;
  logradouro?: string;
  numero?: string;
  cidade?: string;
  bairro?: string;
  complemento?: string;
  uf?: string;
  localidade?: string;
  pais?: string;
}

export interface CompanyDetailForm extends CompanyDataBodyRequest {
  nome?: string;
  groupInfo: {
    isGroup: boolean;
    groupName?: string;
    groupId?: string;
  };
  cpf?: IDefaultReturn;
  cnpj?: IDefaultReturn;
  telefone?: IDefaultReturn;
  dataNascimento?: IDefaultReturn;
  razaoSocial?: string;
  email?: string;
  nomeFantasia?: string;
  cep?: IDefaultReturn;
  logradouro?: string;
  numero?: string;
  cidade?: string;
  bairro?: string;
  complemento?: string;
  uf?: string;
  localidade?: string;
  pais?: string;
  representanteLegal?: string;
  cargoRepresentante?: string;
  cpfRepresentante?: IDefaultReturn;
  telefoneRepresentanteLegal?: IDefaultReturn;
  emailRepresentanteLegal?: string;
  dataNascimentoRepresentante?: IDefaultReturn;
  parameters?: {
    general: GeneralParametersData;
    bankData: BankData;
    splits: SplitsModality[];
  };
}

interface IEstablishment {
  nome?: string;
  cpf?: string;
  cnpj?: string;
  telefone?: string;
  dataNascimento?: string;
  email?: string;
  nomeFantasia?: string;
  endereco?: Address;
  representanteLegal?: string;
  cargoRepresentante?: string;
  cpfRepresentanteLegal?: string;
  dataNascimentoRepresentante?: string;
  telefoneRepresentanteLegal?: string;
  emailRepresentanteLegal?: string;
}

interface BusinessGroupData {
  name: string;
  generalParameters: GeneralParametersData;
  homeAccount: Record<string, unknown>;
  splitsModalities: Array<{
    splitPayment?: string;
    modality?: string;
    percentual?: number;
    percentualSplit?: number;
  }>;
}

interface IState {
  id: string;
  document?: string;
  groupId?: string;
  businessGroupData?: BusinessGroupData;
  defaultTab?: number;
}

type TypeOfPerson = 'fisica' | 'juridica' | null;

const BUSINESS_GROUP_TAB_INDEX = 2;

const initialData: CompanyDataBodyRequest = {
  companyData: {
    splitsModalities: [
      {
        modality: 'A_VISTA',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_2X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_3X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_4X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_5X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_6X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_7X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_8X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_9X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_10X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_11X',
        percentualSplit: 0,
      },
      {
        modality: 'PARCELADO_12X',
        percentualSplit: 0,
      },
    ],
    businessGroupInfoData: {
      isCompanyBusinessGroup: false,
      businessGroupData: {
        name: '',
        id: '',
      },
    },
  },
  bankData: {
    accountHolder: { cpfCnpj: '', holderName: '' },
    account: '',
    agency: '',
    bank: '',
    bankName: '',
    code: '',
    digit: '',
    type: '',
  },
  responsiblesData: {
    cpf: '',
    dateOfBirth: '',
    email: '',
    name: '',
    phone: '',
    role: '',
    surname: '',
  },
};
const RegisterTeuPagEstablishment = () => {
  const [form, setForm] = useState<CompanyDataBodyRequest>(initialData);
  const [typeOfPerson, setTypeOfPerson] = useState<TypeOfPerson>(null);
  const [dialogError, setDialogError] = useState(false);
  const [dialogMessage, setDialogMessage] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const { state } = useLocation<IState>();

  console.log(state);

  const isEditing = !!state?.id || !!state?.document;
  const isEditingGroup = !!state?.groupId;

  const RequestGetDetailsEstablishment = useApi<IEstablishment>(
    Endpoints.establishments.getDetailEstablishments.replace(
      'PARAM_ID',
      state?.id,
    ),
    ApiMethod.GET,
  );

  const GetAddressByCep = useApi<Address>(
    Endpoints.consult.getAddressByCep.replace(
      'PARAM_CEP',
      form?.companyData?.addressZipCode?.unmasked,
    ),
    ApiMethod.GET,
  );

  const GetAddressByGeolocation = useApi<Address>(
    Endpoints.integration.getAddressByGeolocation,
    ApiMethod.GET,
    {},
    true,
  );

  const getDetailsEstablishments = async () => {
    try {
      setLoading(true);

      const response = await httpRequest<CompanyDataResponse>({
        url: Endpoints.companies.getCompanyDetails.replace(
          'PARAM_CPF',
          state.document,
        ),
      });

      const { data } = response;
      const address = data.address[0];
      const contact = data.contacts[0];
      const bank = data.homeAccount;
      const businessGroup = data.businessGroups?.[0];
      const images = data?.images;

      const cnpjObject: Partial<CompanyDataBodyRequest> = {
        savedImages: images,

        companyData: {
          partnership: data.partnership,
          tradeName: data.name,
          fantasyName: data.nickname,
          email: data.email,
          addressStreet: address.address,
          addressNumber: address.number,
          addressComplement: address.complement,
          addressDistrict: address.neighborhood,
          addressCity: address.cityName,
          addressState: address.state,
          addressZipCode: cepMask(address.zipCode),
          cnpj: cnpjMask(data?.document),
          phone: phoneMask(data?.phone),
          cpf: cpfMask(data?.document),
          addressCountry: address.country,
          id: data.id,
          category: data.category.name,
          operationLimit: 0,
          packageData: {
            merchantDiscountRate: 0,
            clientUCC: 0,
          },
          businessGroupInfoData: {
            isCompanyBusinessGroup: data.isBusinessGroup,
            businessGroupData: businessGroup,
          },
          generalParametersData: data.generalParameters
            ? {
                mcc: data.generalParameters.mcc,
                captureMethod: data.generalParameters.captureMethod,
                posQuantity: data.generalParameters.posQuantity,
                monthlyCardTotalRevenue:
                  data.generalParameters.monthlyCardTotalRevenue,
                repassCondition: data.generalParameters.repassCondition,
              }
            : {},
          generalParametersAgreement: data.generalParametersAgreement
            ? {
                invoiceDueDay: dateMask(
                  data.generalParametersAgreement.invoiceDueDay,
                ),
                invoiceEmails: data.generalParametersAgreement.invoiceEmails.map(
                  (i) => ({
                    id: i,
                    value: i,
                  }),
                ),
              }
            : {},
          splitsModalities: data.splitsModalities?.length
            ? data.splitsModalities.map((split) => ({
                modality: split.splitPayment,
                percentualSplit: split.percentual,
              }))
            : initialData.companyData.splitsModalities,
        },
        bankData: !!bank
          ? {
              accountHolder: {
                holderName: bank.accountHolder.holderName,
                cpfCnpj:
                  bank.accountHolder.cpfCnpj.length > 11
                    ? cnpjMask(bank.accountHolder.cpfCnpj)
                    : cpfMask(bank.accountHolder.cpfCnpj),
              },
              bankName: bank.bankFullName,
              agency: bank.branch,
              account: bank.account,
              digit: bank.digit,
              bank: bank.bankIspb,
              code: bank.bankCode,
              type: bank.accountType.replace('_', ''),
            }
          : {},

        responsiblesData: {
          name: contact.name,
          surname: contact.name.split(' ').slice(1).join(' '),
          cpf: cpfMask(contact?.cpf),
          email: contact.email,
          phone: phoneMask(contact.cellPhone),
          occupation: contact.occupation,
          dateOfBirth: dateMask(
            moment(contact?.dateOfBirth, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          ),
        },
        active: data.active,
        shouldFilterByLocation: data.shouldFilterByLocation,
      };
      const cpfObject: Partial<CompanyDataBodyRequest> = {
        savedImages: images,

        companyData: {
          partnership: data.partnership,
          tradeName: data.name,
          fantasyName: data.nickname,
          email: data.email,
          addressStreet: address.address,
          addressNumber: address.number,
          addressComplement: address.complement,
          addressDistrict: address.neighborhood,
          addressCity: address.cityName,
          addressState: address.state,
          addressZipCode: cepMask(address.zipCode),
          cnpj: cpfMask(data?.document),
          phone: phoneMask(contact?.cellPhone),
          cpf: cpfMask(data?.document),
          addressCountry: address.country,
          id: data.id,
          category: data.category.name,
          operationLimit: 0,
          packageData: {
            merchantDiscountRate: 0,
            clientUCC: 0,
          },
          businessGroupInfoData: {
            isCompanyBusinessGroup: data.isBusinessGroup,
            businessGroupData: businessGroup,
          },
          generalParametersData: data.generalParameters
            ? {
                mcc: data.generalParameters.mcc,
                captureMethod: data.generalParameters.captureMethod,
                posQuantity: data.generalParameters.posQuantity,
                monthlyCardTotalRevenue:
                  data.generalParameters.monthlyCardTotalRevenue,
                repassCondition: data.generalParameters.repassCondition,
              }
            : {},
          generalParametersAgreement: data.generalParametersAgreement
            ? {
                invoiceDueDay: dateMask(
                  data.generalParametersAgreement.invoiceDueDay,
                ),
                invoiceEmails: data.generalParametersAgreement.invoiceEmails.map(
                  (i) => ({
                    id: i,
                    value: i,
                  }),
                ),
              }
            : {},
          splitsModalities: data.splitsModalities?.length
            ? data.splitsModalities.map((split) => ({
                modality: split.splitPayment,
                percentualSplit: split.percentual,
              }))
            : initialData.companyData.splitsModalities,
        },
        bankData: !!bank
          ? {
              accountHolder: {
                holderName: bank.accountHolder.holderName,
                cpfCnpj:
                  bank.accountHolder.cpfCnpj.length > 11
                    ? cnpjMask(bank.accountHolder.cpfCnpj)
                    : cpfMask(bank.accountHolder.cpfCnpj),
              },
              bankName: bank.bankFullName,
              agency: bank.branch,
              account: bank.account,
              digit: bank.digit,
              bank: bank.bankIspb,
              code: bank.bankCode,
              type: bank.accountType.replace('_', ''),
            }
          : {},

        responsiblesData: {
          name: contact.name,
          surname: contact.name.split(' ').slice(1).join(' '),
          cpf: cpfMask(contact?.cpf),
          email: contact.email,
          phone: phoneMask(contact.cellPhone),
          occupation: contact.occupation,
          dateOfBirth: dateMask(
            moment(contact?.dateOfBirth, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          ),
        },
        active: data.active,
        shouldFilterByLocation: data.shouldFilterByLocation,
      };

      if (response.status === 200) {
        const isPf = data?.companyType === 'PESSOA_FISICA';
        setForm(isPf ? cpfObject : cnpjObject);

        setTypeOfPerson(isPf ? 'fisica' : 'juridica');
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.log(error);
    }
  };

  const isUserEditingCep = useRef(!isEditing);

  const handleGetCep = async () => {
    const response = await GetAddressByCep.callApi();
    if (response.status >= 200 && response.status <= 300) {
      setForm((prev) => ({
        ...prev,
        companyData: {
          ...prev.companyData,
          addressStreet: response?.data?.logradouro || '',
          ...(isUserEditingCep.current && {
            addressNumber: '',
            addressComplement: '',
          }),
          addressDistrict: response?.data?.bairro || '',
          addressCity: response?.data?.localidade || '',
          addressState: response?.data?.uf || '',
        },
      }));
    }
    isUserEditingCep.current = true;
  };

  const handleGetAddressByGeolocation = async (lat: number, lon: number) => {
    try {
      const response = await GetAddressByGeolocation.callApi({ lat, lon });
      if (response.status >= 200 && response.status <= 300) {
        setForm((prev) => ({
          ...prev,
          companyData: {
            ...prev.companyData,
            addressStreet: response?.data?.logradouro || '',
            addressDistrict: response?.data?.bairro || '',
            addressCity: response?.data?.cidade || '',
            addressState: response?.data?.uf || '',
            addressZipCode: cepMask(response?.data?.cep),
          },
        }));
      } else {
        setMessageError(
          'Não foi possível obter o endereço para a localização selecionada.',
        );
        setDialogMessage(true);
      }
    } catch (error) {
      setMessageError(
        'Não foi possível obter o endereço para a localização selecionada.',
      );
      setDialogMessage(true);
    }
  };

  useEffect(() => {
    if (
      form?.companyData?.addressZipCode?.unmasked?.length === 8 &&
      !form?.companyData?.addressLatitude &&
      !form?.companyData?.addressLongitude
    ) {
      if (!isUserEditingCep.current) {
        isUserEditingCep.current = true;
        return;
      }
      handleGetCep();
    }
  }, [form?.companyData?.addressZipCode]);

  useEffect(() => {
    if (state?.document) {
      getDetailsEstablishments();
    }
  }, [state?.document]);

  const handleInitialTab = (person) => {
    if (isEditingGroup || state?.defaultTab === BUSINESS_GROUP_TAB_INDEX)
      return BUSINESS_GROUP_TAB_INDEX;
    if (person === 'juridica') return 1;
    return 0;
  };

  return (
    <>
      <Loading
        status={
          RequestGetDetailsEstablishment.loading ||
          GetAddressByCep.loading ||
          GetAddressByGeolocation.loading ||
          loading
        }
      />
      <Dialog
        icon={icons.exclamation}
        open={dialogError}
        positiveLabel="Entendi"
        positiveAction={() => {
          setDialogError(false);
          history.push('/teu-pag/estabelecimento');
        }}
        message={messageError}
      />
      <Dialog
        icon={icons.exclamation}
        open={dialogMessage}
        positiveLabel="Entendi"
        positiveAction={() => {
          setDialogMessage(false);
        }}
        message={messageError}
      />
      <Container>
        <St.BoxCard>
          <ContainerFlex>
            <Tabs initialTab={handleInitialTab(typeOfPerson)} align="left">
              <Tabs.Tab
                label="Pessoa Física"
                icon={pessoaFisicaIcon}
                activeIcon={activePessoaFisicaIcon}
                disabled={
                  isEditingGroup ||
                  (typeOfPerson === 'juridica' && Boolean(state?.id))
                }
              >
                <CPFEstablishment
                  form={form}
                  setForm={setForm}
                  handleGetCep={handleGetCep}
                  handleGetAddressByGeolocation={handleGetAddressByGeolocation}
                />
              </Tabs.Tab>
              <Tabs.Tab
                label="Pessoa Jurídica"
                icon={pessoaJuridicaIcon}
                activeIcon={activePessoaJuridicaIcon}
                disabled={
                  isEditingGroup ||
                  (typeOfPerson === 'fisica' && Boolean(state?.id))
                }
              >
                <CNPJEstablishment
                  form={form}
                  setForm={setForm}
                  handleGetCep={handleGetCep}
                  handleGetAddressByGeolocation={handleGetAddressByGeolocation}
                />
              </Tabs.Tab>
              <Tabs.Tab
                label="Grupo Econômico"
                icon={grupoEconomicoIcon}
                activeIcon={activeGrupoEconomicoIcon}
                disabled={!!state?.document || !!state?.id}
              >
                <BusinessGroupEstablishment
                  groupId={state?.groupId}
                  businessGroupData={state?.businessGroupData}
                />
              </Tabs.Tab>
            </Tabs>
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </>
  );
};

export default RegisterTeuPagEstablishment;
